import { http } from '../../http/client';
import type { Summernote } from './summernote';

export default class SummernoteClient {
  create(blob: Blob): Promise<Summernote> {
    const data = new FormData();
    data.append('summernote[image]', blob);
    return http.post<Summernote>('/api/v1/summernotes', { body: data });
  }

  createMy(blob: Blob): Promise<Summernote> {
    const data = new FormData();
    data.append('summernote[image]', blob);
    return http.post<Summernote>('/my/summernotes', { body: data });
  }
}
